import React from 'react';
import 'twin.macro';
import { ChevronLeftIcon as ChevronLeft } from '@heroicons/react/24/outline';
import { UserLocale } from '@teetsh/app/src/types/user';
import { AvatarCard } from 'components/AvatarCard';
import SchoolyearButtonLink from 'components/Buttons/SchoolyearButtonLink';
import ScreenSpinner from 'components/Spinner/ScreenSpinner';
import { NavigationTabs } from 'containers/Eleves/EleveDetails/Main/NavigationTabs';
import { elevesUrls } from 'containers/Eleves/urls';
import useEleves from 'queries/eleves/useEleves';
import { useTranslation } from 'react-i18next';
import {
  Navigate,
  Outlet,
  ScrollRestoration,
  useParams,
} from 'react-router-dom';
import { format } from 'utils/time/format';

export function Main() {
  const { eleveId } = useParams<{ eleveId }>();
  const { t } = useTranslation(['common', 'eleve']);
  const { data: eleves = [], isLoading } = useEleves();

  if (isLoading) {
    return <ScreenSpinner />;
  }
  const eleve = eleves.find(v => v.id === eleveId);
  if (!eleve) {
    return <Navigate to="/eleves" />;
  }
  return (
    <div key={eleveId}>
      <ScrollRestoration />
      <div tw="md:px-4 sm:px-6 lg:px-8 py-4 md:py-8 md:flex md:items-center md:justify-between md:space-x-5 bg-white shadow">
        <div tw="flex items-center space-x-5">
          <div tw="flex-shrink-0">
            <AvatarCard
              picture={eleve.picture === 'user' ? undefined : eleve.picture}
              tw="hidden md:block"
            />
          </div>
          <SchoolyearButtonLink
            tw="md:hidden"
            large
            minimal
            aria-label="Aller à la liste des élèves"
            to={elevesUrls.all}
            icon={ChevronLeft}
          />

          <div tw="text-left">
            <div tw="flex items-center gap-4">
              <h1 tw="text-2xl font-bold text-neutral-intense">
                {eleve.givenName} {eleve.familyName}
              </h1>
            </div>
            {eleve.birthday && (
              <p tw="hidden md:block text-sm font-medium text-neutral-quiet">
                {t('eleve:born', {
                  date: format(
                    eleve.birthday,
                    t('common:locale.long') as UserLocale,
                    t('common:datePattern.dd/MM/yyyy'),
                  ),
                })}
              </p>
            )}
          </div>
        </div>
      </div>
      <div tw="sm:px-4 md:px-8 xl:px-10 pt-3">
        <div tw="px-3 md:px-0">
          <NavigationTabs tw="mb-6" eleveId={eleveId} />
        </div>
        <Outlet context={{ eleve }} />
      </div>
    </div>
  );
}
